/**
 * Objects slice – recently used list. Reference pattern: createAsyncThunk + API module.
 */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { objectsAPI } from "../../api/objectsAPI";
import UserAuth from "../../../auth/userAuth";
import { logger } from "../../../utils/logger";

export const fetchRecentlyUsedList = createAsyncThunk(
  "objects/fetchRecentlyUsedList",
  async (_, { rejectWithValue }) => {
    logger.info("fetchRecentlyUsedList start", null, "REDUX");
    try {
      const tokenResponse = await new UserAuth().getUserToken(true);
      const accessToken = tokenResponse?.accessToken;
      if (!accessToken) {
        logger.error("fetchRecentlyUsedList no access token", tokenResponse, "REDUX");
        return rejectWithValue({ message: "No access token", code: "UNAUTHORIZED" });
      }
      const result = await objectsAPI.getRecentlyUsedList(accessToken);
      logger.info("fetchRecentlyUsedList success", null, "REDUX");
      return result;
    } catch (err) {
      logger.error("fetchRecentlyUsedList failed", err, "REDUX");
      return rejectWithValue({
        message: err.message ?? "Request failed",
        code: err.code ?? err.response?.status,
      });
    }
  }
);

const initialState = {
  recentlyUsedList: [],
  recentlyUsedLoading: false,
  recentlyUsedError: null,
};

const objectsSlice = createSlice({
  name: "objects",
  initialState,
  reducers: {
    clearRecentlyUsedError: (state) => {
      state.recentlyUsedError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentlyUsedList.pending, (state) => {
        state.recentlyUsedLoading = true;
        state.recentlyUsedError = null;
      })
      .addCase(fetchRecentlyUsedList.fulfilled, (state, action) => {
        state.recentlyUsedLoading = false;
        state.recentlyUsedList = action.payload?.data ?? [];
      })
      .addCase(fetchRecentlyUsedList.rejected, (state, action) => {
        state.recentlyUsedLoading = false;
        state.recentlyUsedError = action.payload ?? { message: "Unknown error" };
      });
  },
});

export const { clearRecentlyUsedError } = objectsSlice.actions;
export default objectsSlice.reducer;
